import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6b010f8a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6b010f8a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b010f8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b010f8a')) {
      api.createRecord('6b010f8a', component.options)
    } else {
      api.reload('6b010f8a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6b010f8a&scoped=true", function () {
      api.rerender('6b010f8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/configure/interface/index.vue"
export default component.exports